import { memo } from 'react';
import { StyledFooter } from '../styled';
import FooterLinks from '../FooterLinks/FooterLinks';
import Copyrights from '../Copyrights/Copyrights';

const Footer = memo((props) => (
  <StyledFooter>
    <FooterLinks {...props} />
    <Copyrights {...props} />
  </StyledFooter>
));

export default Footer;
